export default __webpack_public_path__ + "static/media/hard-hat.91016601.svg";